import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import styles from "./Style.module.css";
import sidebarStyle from "../../assets/img/logos-img/certifications.png";
import RouteName from "../../routes/Route.name";

function LandingPage() {
  
  const history = useHistory();

  useEffect(() => {
    if (window.innerWidth > 768) {
      history.push(`/`);
    }
  }, []);

  const handleViewDashboard = () => {
      history.push(RouteName.EMP_DASHBOARD);
  };

  const handleAccessMenu = () => {
      history.push({
          pathname: RouteName.EMP_DASHBOARD,
          search: "?openSidebar=true"
      });
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.contentTop}>
        <div className={styles.sinceText}>since 1986</div>

        <h1 className={styles.mainHeading}>
          Welcome to
          <br />
          Ind-Swift
          <br />
          Group
        </h1>

        <p className={styles.description}>
          We develop high-quality, research-driven pharmaceutical products for a
          healthier world.
        </p>

        <div className={styles.slogan}>
          One World
          <br />
          One Health
          <br />
          One Ind-Swift
        </div>
      </div>

      <div
        className={styles.buttonGroup}
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "12px",
          alignItems: "center",
        }}
      >
        <button
          className={`${styles.btn} ${styles.btnPrimary}`}
          style={{ width: "auto", flex: "none" }}
          onClick={handleViewDashboard}
        >
          VIEW DASHBOARD
        </button>

        <button
          className={`${styles.btn} ${styles.btnSecondary}`}
          style={{ width: "auto", flex: "none" }}
          onClick={handleAccessMenu}
        >
          ACCESS MENU
        </button>
      </div>

      <img
        src={sidebarStyle}
        alt="Certifications"
        className={styles.certificationsLogo}
      />
    </div>
  );
}

export default LandingPage;
